import React, { useState, useEffect, useRef } from 'react';
import { Box, Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import { db } from '../../services/firebase/config';
import { collection, getDocs } from 'firebase/firestore';

const imagePaths = [
  '/poolAnimation/pool1.jpeg',
  '/poolAnimation/pool2.jpeg',
  '/poolAnimation/pool3.jpeg',
  '/poolAnimation/pool4.jpeg',
  '/poolAnimation/pool5.jpeg',
  '/poolAnimation/pool6.jpeg',
];

const PoolAnimationDisplay = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeUsers, setActiveUsers] = useState([]);
  const animationContainerRef = useRef(null);

  // Fetch users with active pool passes
  useEffect(() => {
    const fetchActiveUsers = async () => {
      const usersCollectionRef = collection(db, 'users');
      const querySnapshot = await getDocs(usersCollectionRef);
      const usersData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      const today = new Date().toISOString().slice(0, 10);

      const usersWithActivePass = usersData.filter(user => {
        if (!user.poolPasses || user.poolPasses.length === 0) return false;
        return user.poolPasses.some(pass => {
          if (pass.type === 'season') return true;
          if (pass.type === 'day' && (pass.purchasedAt || '').slice(0, 10) === today) return true;
          return false;
        });
      });

      setActiveUsers(usersWithActivePass);
    };

    fetchActiveUsers();
  }, []);

  // Image sequence loop
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagePaths.length);
    }, 1500); // Change image every 1500ms
    return () => clearInterval(interval);
  }, []);

  // Random position for user avatars
  const getRandomPosition = () => {
    if (animationContainerRef.current) {
      const { clientWidth, clientHeight } = animationContainerRef.current;
      const avatarSize = 40; // Approximate size of the avatar
      const x = Math.random() * (clientWidth - avatarSize);
      const y = Math.random() * (clientHeight - avatarSize);
      return { x, y };
    }
    return { x: 0, y: 0 };
  };

  return (
    <Box
      ref={animationContainerRef}
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: 800,
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        mb: 4,
      }}
    >
      <Box
        component="img"
        src={imagePaths[currentImageIndex]}
        alt="Pool Animation"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />

      {activeUsers.map((user) => {
        const { x, y } = getRandomPosition();
        return (
          <Avatar
            key={user.id}
            src={user.photoURL || '/default-avatar.png'} // Use a default avatar if photoURL is not available
            alt={user.name || 'User'}
            sx={{
              position: 'absolute',
              left: x,
              top: y,
              width: 40,
              height: 40,
              border: '2px solid white',
              transition: 'all 5s linear', // Smooth movement over 5 seconds
            }}
          />
        );
      })}
    </Box>
  );
};

export default PoolAnimationDisplay;
